import { render, staticRenderFns } from "./schedule-list.vue?vue&type=template&id=7350b1b4&scoped=true"
import script from "./schedule-list.vue?vue&type=script&lang=js"
export * from "./schedule-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7350b1b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7350b1b4')) {
      api.createRecord('7350b1b4', component.options)
    } else {
      api.reload('7350b1b4', component.options)
    }
    module.hot.accept("./schedule-list.vue?vue&type=template&id=7350b1b4&scoped=true", function () {
      api.rerender('7350b1b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/chat/schedule-message/schedule-list.vue"
export default component.exports